import { CSSGenerateResponse, SitePreviewResponse } from '@/common/model/recommend/analysis'
import {
  Widget,
  WidgetContentType,
  WidgetDisplayLogic,
  WidgetLayoutType,
  WidgetStatus
} from '@/common/model/recommend/widget'

export const WidgetApiPath = {
  LIST_WIDGETS: '/api/sites/{site_id}/widgets', // GET List
  GET_WIDGET: '/api/sites/{site_id}/widgets/{widget_id}', // GET Get (by widget_id)
  CREATE_WIDGET: '/api/sites/{site_id}/widgets', // POST Create
  UPDATE_WIDGET: '/api/sites/{site_id}/widgets/{widget_id}', // PUT Update
  DELETE_WIDGET: '/api/sites/{site_id}/widgets/{widget_id}', // DELETE Delete
  GENERATE_CSS: '/api/sites/{site_id}/widgets/generate-css', // POST Generate Css
  SITE_PREVIEW: '/api/sites/{site_id}/widgets/site-preview' // POST Site Preview
}

export type WidgetApiPath = (typeof WidgetApiPath)[keyof typeof WidgetApiPath]

export interface ListWidgetsVars {
  site_id: number
  // 任意の絞り込み（未指定＝すべて）
  content_type?: WidgetContentType
  display_logic?: WidgetDisplayLogic
}

export interface GetWidgetVars {
  site_id: number
  widget_id: number
}

export interface CreateWidgetVars {
  site_id: number
  name: string
  display_logic: WidgetDisplayLogic
  content_type?: WidgetContentType
  title_template?: string | null
  layout_type?: WidgetLayoutType
  max_items?: number
  custom_css?: string | null
  status?: WidgetStatus
  widget_page_id?: number | null
}

export interface UpdateWidgetVars {
  site_id: number
  widget_id: number
  name?: string | null
  display_logic?: WidgetDisplayLogic | null
  content_type?: WidgetContentType | null
  title_template?: string | null
  layout_type?: WidgetLayoutType | null
  max_items?: number | null
  custom_css?: string | null
  status?: WidgetStatus | null
  widget_page_id?: number | null
}

export interface DeleteWidgetVars {
  site_id: number
  widget_id: number
}

// AI CSS生成 / サイトプレビュー（VisualCssEditorModal が使用）
// widget_page_id 指定時はバックエンドが設置ページのURL/Basic認証を解決する。
export interface GenerateCssVars {
  site_id: number
  site_url?: string
  instructions?: string
  basic_auth_user?: string | null
  basic_auth_pass?: string | null
  widget_page_id?: number | null
}

export interface SitePreviewVars {
  site_id: number
  site_url?: string
  basic_auth_user?: string | null
  basic_auth_pass?: string | null
  widget_page_id?: number | null
}

export type ListWidgetsResponse = Widget[]
export type GetWidgetResponse = Widget
export type CreateWidgetResponse = Widget
export type UpdateWidgetResponse = Widget

export interface DeleteWidgetResponse {
  deleted: boolean
}

export type GenerateCssResponse = CSSGenerateResponse
export type SitePreviewResponse2 = SitePreviewResponse
